var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CopySelectedEntries, DeleteSelectedEntries, DownloadEntries, OpenDialog, OpenFilePreview, RemoveEntries, } from '../../state/actions/commands';
import { DriveContextActions } from '../drive-context-actions';
import { ShareLinkDialogComponent } from '../../sharing/share-link-dialog/share-link-dialog.component';
import { Store } from '@ngxs/store';
import { CurrentUser } from 'common/auth/current-user';
import { SharesApiService } from '../../sharing/shares-api.service';
import { ShareDialogComponent } from '../../sharing/share-dialog/share-dialog.component';
import { RenameEntryDialogComponent } from '../../entries/rename-entry-dialog/rename-entry-dialog.component';
import { DriveState } from '../../state/drive-state';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "../../../../common/auth/current-user";
import * as i3 from "../../sharing/shares-api.service";
var noopTrue = function () { return true; };
var ɵ0 = noopTrue;
var SharesActions = /** @class */ (function (_super) {
    __extends(SharesActions, _super);
    function SharesActions(store, currentUser, shares) {
        var _this = _super.call(this, store) || this;
        _this.store = store;
        _this.currentUser = currentUser;
        _this.shares = shares;
        _this.actions = [
            {
                viewName: 'Preview',
                icon: 'visibility',
                execute: function () {
                    _this.store.dispatch(new OpenFilePreview());
                },
                visible: function () {
                    return !_this.onlyFoldersSelected;
                },
            },
            {
                viewName: 'Manage People',
                icon: 'person-add',
                showInCompact: true,
                execute: function () {
                    _this.store.dispatch(new OpenDialog(ShareDialogComponent, null, 'share-dialog-container'));
                },
                visible: function () {
                    return _this.userHasPermission('edit');
                },
            },
            {
                viewName: 'Get shareable link',
                icon: 'link',
                execute: function () {
                    _this.store.dispatch(new OpenDialog(ShareLinkDialogComponent, null, {
                        panelClass: 'share-link-dialog-container',
                        autoFocus: false,
                    }));
                },
                visible: function () {
                    return !_this.multipleEntriesSelected && _this.userHasPermission('edit');
                }
            },
            {
                viewName: 'Rename',
                icon: 'edit',
                execute: function () {
                    _this.store.dispatch(new OpenDialog(RenameEntryDialogComponent, null, 'rename-entry-dialog-container'));
                },
                visible: function () {
                    return !_this.multipleEntriesSelected && _this.userHasPermission('edit');
                }
            },
            {
                viewName: 'Add to my drive',
                icon: 'add-box',
                execute: function () {
                    _this.store.dispatch(new CopySelectedEntries());
                },
                visible: noopTrue,
            },
            {
                viewName: 'Make a copy',
                icon: 'content-copy',
                execute: function () {
                    _this.store.dispatch(new CopySelectedEntries());
                },
                visible: noopTrue,
            },
            {
                viewName: 'Download',
                icon: 'file-download',
                execute: function () {
                    _this.store.dispatch(new DownloadEntries());
                },
                visible: function () {
                    return _this.userHasPermission('download');
                },
            },
            {
                viewName: 'Delete',
                icon: 'delete',
                showInCompact: true,
                execute: function () {
                    _this.delete();
                },
                visible: noopTrue,
            },
        ];
        return _this;
    }
    SharesActions.prototype.userHasPermission = function (permission) {
        var _this = this;
        return this.getSelectedEntries().every(function (entry) {
            if (!entry.users)
                entry.users = [];
            var user = entry.users.find(function (u) { return u.id === _this.currentUser.get('id'); });
            return user && (user.owns_entry || user.entry_permissions[permission]);
        });
    };
    SharesActions.prototype.delete = function () {
        var _this = this;
        var entries = this.getSelectedEntries();
        // if user owns or can edit selected entries, delete them
        if (this.store.selectSnapshot(DriveState.userCanEditSelectedEntries)) {
            this.store.dispatch(new DeleteSelectedEntries());
            // otherwise, just remove entries from user's "shared with me" page
        }
        else {
            this.shares.detachUser(this.currentUser.get('id'), entries.map(function (e) { return e.id; })).subscribe(function () {
                _this.store.dispatch(new RemoveEntries(entries));
            });
        }
    };
    SharesActions.ngInjectableDef = i0.defineInjectable({ factory: function SharesActions_Factory() { return new SharesActions(i0.inject(i1.Store), i0.inject(i2.CurrentUser), i0.inject(i3.SharesApiService)); }, token: SharesActions, providedIn: "root" });
    return SharesActions;
}(DriveContextActions));
export { SharesActions };
export { ɵ0 };
